export const TAG_JOB = "TAG_JOB";
export const TAG_JOB_SUCCESS = "TAG_JOB_SUCCESS";
export const TAG_JOB_FAILURE = "TAG_JOB_FAILURE";
export const TAG_JOB_RESET = "TAG_JOB_RESET";

export const UNTAG_JOB = "UNTAG_JOB";
export const UNTAG_JOB_SUCCESS = "UNTAG_JOB_SUCCESS";
export const UNTAG_JOB_FAILURE = "UNTAG_JOB_FAILURE";
export const UNTAG_JOB_RESET = "UNTAG_JOB_RESET";

export const TAG_JOB_ALL = "TAG_JOB_ALL";
export const TAG_JOB_ALL_SUCCESS = "TAG_JOB_ALL_SUCCESS";
export const TAG_JOB_ALL_FAILURE = "TAG_JOB_ALL_FAILURE";

export const FETCH_JOB_TIMELINE_LIST = "FETCH_JOB_TIMELINE_LIST";
export const FETCH_JOB_TIMELINE_LIST_SUCCESS =
  "FETCH_JOB_TIMELINE_LIST_SUCCESS";
export const FETCH_JOB_TIMELINE_LIST_FAILURE =
  "FETCH_JOB_TIMELINE_LIST_FAILURE";

export const JOB_TIMELINE_COUNT = "JOB_TIMELINE_COUNT";
export const JOB_TIMELINE_COUNT_SUCCESS = "JOB_TIMELINE_COUNT_SUCCESS";
export const JOB_TIMELINE_COUNT_FAILURE = "JOB_TIMELINE_COUNT_FAILURE";

export const TAG_JOB_ATTACHMENT = "TAG_JOB_ATTACHMENT";
export const TAG_JOB_ATTACHMENT_SUCCESS = "TAG_JOB_ATTACHMENT_SUCCESS";
export const TAG_JOB_ATTACHMENT_FAILURE = "TAG_JOB_ATTACHMENT_FAILURE";
export const TAG_JOB_ATTACHMENT_RESET = "TAG_JOB_ATTACHMENT_RESET";

export const TAG_JOB_FILES = "TAG_JOB_FILES";
export const TAG_JOB_FILES_SUCCESS = "TAG_JOB_FILES_SUCCESS";
export const TAG_JOB_FILES_FAILURE = "TAG_JOB_FILES_FAILURE";
export const TAG_JOB_FILES_RESET = "TAG_JOB_FILES_RESET";

export const FETCH_JOB_TIMELINE_FORM_SUBMISSION =
  "FETCH_JOB_TIMELINE_FORM_SUBMISSION";
export const FETCH_JOB_TIMELINE_FORM_SUBMISSION_SUCCESS =
  "FETCH_JOB_TIMELINE_FORM_SUBMISSION_SUCCESS";
export const FETCH_JOB_TIMELINE_FORM_SUBMISSION_FAILURE =
  "FETCH_JOB_TIMELINE_FORM_SUBMISSION_FAILURE";
export const FETCH_JOB_TIMELINE_FORM_SUBMISSION_RESET =
  "FETCH_JOB_TIMELINE_FORM_SUBMISSION_RESET";

export const UPDATE_BILL_RATE_RESET = "UPDATE_BILL_RATE_RESET";
export const UPDATE_BILL_RATE = "UPDATE_BILL_RATE";
export const UPDATE_BILL_RATE_SUCCESS = "UPDATE_BILL_RATE_SUCCESS";
export const UPDATE_BILL_RATE_FAILURE = "UPDATE_BILL_RATE_FAILURE";

export const FETCH_JOB_CANDIDATE_STAGE = "FETCH_JOB_CANDIDATE_STAGE";
export const FETCH_JOB_CANDIDATE_STAGE_SUCCESS =
  "FETCH_JOB_CANDIDATE_STAGE_SUCCESS";
export const FETCH_JOB_CANDIDATE_STAGE_FAILURE =
  "FETCH_JOB_CANDIDATE_STAGE_FAILURE";

export const SET_APPROVE_TAG_SUCCESS = "SET_APPROVE_TAG_SUCCESS";
export const RESET_APPROVE_TAG_SUCCESS = "RESET_APPROVE_TAG_SUCCESS";

export const UPLOAD_PRE_OFFER_FILES = "UPLOAD_PRE_OFFER_FILES";
export const UPLOAD_PRE_OFFER_FILES_SUCCESS = "UPLOAD_PRE_OFFER_FILES_SUCCESS";
export const UPLOAD_PRE_OFFER_FILES_FAILURE = "UPLOAD_PRE_OFFER_FILES_FAILURE";
export const UPLOAD_PRE_OFFER_FILES_RESET = "UPLOAD_PRE_OFFER_FILES_RESET";
